import jsPDF from 'jspdf';

export function renderPdfFooter(
  doc: jsPDF,
  pageNumber: number,
  totalPages: number,
  margins: { bottom: number; left: number; right: number },
  geradoPor?: string
): void {
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const footerY = pageHeight - margins.bottom + 5;

  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(150, 150, 150);

  // Número da página (direita)
  doc.text(
    `Página ${pageNumber} de ${totalPages}`,
    pageWidth - margins.right - 20,
    footerY
  );

  // Gerado por (esquerda)
  const footerText = geradoPor ? `Gerado por ${geradoPor}` : 'Gerado pelo Sistema';
  doc.text(footerText, margins.left, footerY);
}
